<template>
  <div class="root">
    <Slide
      class="bm-slide"
      noOverlay
      :closeOnNavigation="true"
      @openMenu="handleOpenMenu"
      @closeMenu="handleCloseMenu"
      :burgerIcon="showBurgerIcon"
    >
      <a v-if="isAuth" href="#" @click="handleSearchClick">Search</a>
      <router-link v-if="isAuth" :to="{ name: 'List' }">My RUX</router-link>
      <router-link v-if="isAuth" :to="{ name: 'Profile' }">Profile</router-link>
      <router-link v-if="isAuth" :to="{ name: 'PackingList' }">Packing Lists</router-link>
      <a href="https://rux.life/pages/how-to-rux/">How to Rux</a>
      <a href="https://rux.life/collections">shop</a>
      <a v-if="isAuth" href="https://rux.life/pages/referral">Refer A Friend</a>
      <router-link v-if="!isAuth" :to="{ name: 'Login' }">Login</router-link>
      <a v-if="isAuth" href="#" @click="logout"
        >Sign Out
        <img
          class="log-out"
          src="./../assets/log_out-white.svg"
          title="Log Out Of RUX"
      /></a>
    </Slide>
  </div>
</template>

<script>
import { Slide } from 'vue-burger-menu'
import { mapState } from 'vuex'
export default {
  name: 'BurgerMenu',
  components: { Slide },
  data: function () {
    return {
      showMenu: false,
      showBurgerIcon: true,
    }
  },
  computed: {
    ...mapState({
      isAuth: (state) => state.auth.isAuth,
      showSearchBar: (state) => state.rux.showSearchBar,
    }),
  },

  methods: {
    handleSearchClick: function () {
      this.$store.dispatch('rux/showSearchBar', !this.showSearchBar)
    },
    handleOpenMenu: function () {
      this.showMenu = true
      this.showBurgerIcon = false
    },
    handleCloseMenu: function () {
      this.showMenu = false
      this.showBurgerIcon = true
    },
    logout: function () {
      this.$store.dispatch('auth/logout')
    },
  },
}
</script>

<style lang='scss'>
.new-badge {
  fill: $ruxRed;
  width: 30px;
  position: relative;
  top: -12px;
}
.log-out {
  margin-left: 8px;
}


.bm-slide {
  color: white;
  .bm-burger-bars {
    background-color: $ruxBeige;
  }
  .bm-overlay {
    background: $ruxBeige;
  }
.bm-burger-button {
    position: relative !important;
    top: 0px !important;
    left: 0px !important;
    width: 24px !important;
    height: 18px !important;
    margin-right: 8px !important;
  }
.line-style {
    height: 18%;
    color: white;
    background-color: $ruxBeige;
    border-radius: 100px;
}
}
.bm-menu {
  transition: 0.1s !important;
  background-color: $ruxBeige !important;
  box-shadow: 10px 32px 36px #00000029 !important;
  .bm-item-list {
    margin-left: 12px !important;
  }
  a,
  a:hover {
    color: #3E3D3B;
    text-transform: uppercase;
  }
  a:hover {
    text-decoration: none;
  }
}
</style>